export class KladrService {
    private searchUrl = '/api/kladr/search';

    /**
     * Храним отображаемые города, чтобы в любой момент иметь возможность получить имя города по ID для сохранения
     * @type {{}}
     */
    public showedCities = {};

    /**
     * Конфигурация для select2, обернутого разработчиком Димой Беловым в компонент Angular
     *
     * Все доступные опции тут
     * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/4869992bc079b88280b9ff91213528904109e8ae/select2/index.d.ts#L40
     * @returns any
     */
    getConfig(useNameId = true) {
        return {
            ajax: {
                url: this.searchUrl,
                dataType: 'json',
                delay: 250,
                cache: true,
                data: function (params) {
                    return {
                        searchQuery: params.term,
                        type: 5
                    };
                },
                processResults: (data) => {
                    const result = [];
                    this.showedCities = {};
                    data.results.forEach((item) => {
                        /**
                         * Используем в качестве ID поле Name_id
                         */
                        if (useNameId) {
                            item.id = item.name_id;
                        }

                        /* Запоминаем показанные города */
                        this.showedCities[item.id] = item.current_name;
                        item.text = item.current_name;
                        result.push(item);
                    });

                    return {
                        results: result
                    };
                },
            },
            templateResult: function (data) {
                let text;

                if (data.loading === true) {
                    text = data.text; // Поиск...
                } else {
                    text = data.current_name; // Имя, например "Новосеславино село", а далее маленькими буквами доп инфу об адресе

                    /**
                     * Формируем полный адрес, включая все районы, области и т.п., чтобы отобразить его под именем поля.
                     * @type {string}
                     */
                    const fullAddress = ['parent_name', 'parent_2_name', 'parent_3_name']
                        .filter((key) => data[key])
                        .map(key => data[key])
                        .join(', ');

                    if (fullAddress) {
                        text += `<br><small>${fullAddress}</small>`;
                    }
                }

                return `<span>${text}</span>`;
            },
            templateSelection: function (data) {
                if (!data.id) {
                    return data.text;
                }

                return $(
                    '<span>' + data.text + '</span>'
                );
            },
            escapeMarkup: function (markup) {
                return markup;
            },
            minimumInputLength: 3, // Минимум символов для ввода перед поиском
            placeholder: 'Выберите город'
        };
    }
}
